import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { IEthnicity } from "Globals/Models/Ethnicity";

export class EthnicityStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private ethnicity: IEthnicity[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.ethnicity = initialState.ethnicities;
    }

    @MobX.action
    public getEthnicityName(ethnicityId: string | null): string {
        if (ethnicityId == "0" || ethnicityId == null || ethnicityId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => ethnicityId === value.id);
        return value ? value.name : "Unknown";
    }
    @MobX.action
    public getRequiresOther(ethnicityId: string | null): boolean {
        if (ethnicityId == "0" || ethnicityId == null || ethnicityId == "") return false;
        let value = this.getSortedByOrdinal.find((value) => ethnicityId === value.id);
        return value ? value.requiresOther : false;
    }

    @MobX.computed
    public get getSortedByOrdinal(): IEthnicity[] {
        return this.ethnicity.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    public getEthnicityOptions(ethnicityId: string): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "placeholder",
        } as KeyValuePair;

        // Return only active (non-legacy) ethnicities
        let options = this.getSortedByOrdinal.filter((value) => !value.isLegacy).map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];

        // If ethnicityId matches a legacy ethnicity, include it so existing data can be displayed
        if (ethnicityId) {
            const legacyEthnicity = this.ethnicity.find((e) => e.id === ethnicityId);
            if (legacyEthnicity) {
                options.push({ value: legacyEthnicity.id, key: legacyEthnicity.name });
            }
        }

        options.unshift(placeholder);

        return options;
    }
}
